import { defHttp } from '/@/utils/http'

export function configApi(keys: string[]) {
  return defHttp.get({ url: '/api/config', params: { keys } })
}

export function modulesListApi() {
  return defHttp.get({ url: '/api/modules' })
}
